import { NgModule } from "@angular/core";
import { KeeniconComponent } from "./keenicon/keenicon.component";
import { CommonModule } from "@angular/common";
import { InputComponent } from "./input/input.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { DatepickerComponent } from "./datepicker/datepicker.component";
import {
  NgbDatepickerModule,
  NgbModalModule,
  NgbTimepickerModule,
  NgbTypeaheadModule,
} from "@ng-bootstrap/ng-bootstrap";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { NgSelectModule } from "@ng-select/ng-select";
import { SelectComponent } from "./select/select.component";
import { TextareaComponent } from "./textarea/textarea.component";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { DaterangePickerComponent } from "./daterange-picker/daterange-picker.component";
import { SwitchComponent } from "./switch/switch.component";
import { StatusLoadingComponent } from "./status-loading/status-loading.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { RadioComponent } from "./radio/radio.component";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { NgxFileDropModule } from "ngx-file-drop";
import { TimepickerComponent } from "./timepicker/timepicker.component";
import { DatatableComponent } from "./datatable/datatable.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { UploadImageComponent } from "./upload-image/upload-image.component";

@NgModule({
  declarations: [
    KeeniconComponent,
    InputComponent,
    DatepickerComponent,
    DaterangePickerComponent,
    SelectComponent,
    TextareaComponent,
    CheckboxComponent,
    SwitchComponent,
    StatusLoadingComponent,
    RadioComponent,
    FileUploadComponent,
    TimepickerComponent,
    DatatableComponent,
    UploadImageComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgSelectModule,
    NgbTypeaheadModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    NgxFileDropModule,
    NgbTimepickerModule,
    NgxDatatableModule,
    SweetAlert2Module.forChild(),
    NgbModalModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
  ],
  exports: [
    KeeniconComponent,
    InputComponent,
    DatepickerComponent,
    DaterangePickerComponent,
    SelectComponent,
    TextareaComponent,
    CheckboxComponent,
    SwitchComponent,
    StatusLoadingComponent,
    RadioComponent,
    FileUploadComponent,
    TimepickerComponent,
    DatatableComponent,
    UploadImageComponent,
  ],
  providers: [provideNgxMask(), MatDatepickerModule],
})
export class SharedModule { }
